var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 59.0004C85 73.9124 73.8073 86 60 86C46.1927 86 35 73.9124 35 59.0004C35 44.0885 46.1927 32 60 32C73.8073 32 85 44.0885 85 59.0004Z",
    fill: "#FFC300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8843 53.3242C39.8843 47.6304 41.5051 42.3516 44.2647 38C38.6185 42.9406 35 50.5279 35 59.0424C35 73.9312 46.054 86 59.6902 86C68.1116 86 75.5439 81.3935 80 74.3658C75.7734 78.0647 70.4121 80.2817 64.5745 80.2817C50.9383 80.2817 39.8843 68.2129 39.8843 53.3242Z",
    fill: "#F6A11D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.098 99.956C86.098 101.584 74.436 102.903 60.049 102.903C45.662 102.903 34 101.584 34 99.956C34 98.328 45.662 97.009 60.049 97.009C74.436 97.009 86.098 98.328 86.098 99.956Z",
    fill: "#F2F5FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5768 54.0455C54.5768 55.8935 53.0788 57.3915 51.2308 57.3915C49.3838 57.3915 47.8848 55.8935 47.8848 54.0455C47.8848 52.1975 49.3838 50.6995 51.2308 50.6995C53.0788 50.6995 54.5768 52.1975 54.5768 54.0455Z",
    fill: "#004BB9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5215 54.0455C65.5215 55.8935 67.0195 57.3915 68.8665 57.3915C70.7145 57.3915 72.2135 55.8935 72.2135 54.0455C72.2135 52.1975 70.7145 50.6995 68.8665 50.6995C67.0195 50.6995 65.5215 52.1975 65.5215 54.0455Z",
    fill: "#004BB9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3726 37.6447C53.1374 37.2234 54.0989 37.5019 54.5202 38.2667C54.9167 38.9866 54.6933 39.8806 54.0281 40.3345L53.8982 40.4143L46.2152 44.6463C45.4504 45.0676 44.4889 44.7891 44.0676 44.0243C43.6711 43.3045 43.8944 42.4104 44.5597 41.9565L44.6896 41.8767L52.3726 37.6447Z",
    fill: "#FF6600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6994 38.2675C66.0959 37.5477 66.971 37.2586 67.7102 37.5783L67.847 37.6455L75.53 41.8775C76.2948 42.2987 76.5733 43.2602 76.152 44.0251C75.7555 44.7449 74.8805 45.0339 74.1413 44.7142L74.0044 44.6471L66.3214 40.4151C65.5566 39.9938 65.2781 39.0323 65.6994 38.2675Z",
    fill: "#FF6600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2318 63.8774H46.4258C46.4268 65.5424 46.7408 67.1314 47.2998 68.6014H72.3578C72.9158 67.1314 73.2318 65.5424 73.2318 63.8774Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8298 77.2761C64.8008 77.2761 69.1308 74.5631 71.4428 70.5431C71.7998 69.9261 72.1018 69.2751 72.3578 68.6011H47.3008C47.5568 69.2751 47.8588 69.9261 48.2158 70.5431C50.5278 74.5631 54.8578 77.2761 59.8298 77.2761Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFace);
export default __webpack_public_path__ + "static/media/empty-face.e33e5c86be27559f2dd122c81e256ec7.svg";
export { ForwardRef as ReactComponent };